import Newsletter_47_container from "./container/Newsletter_47_container";
export default Newsletter_47_container;
